import { useLayoutEffect, useState, useCallback } from 'react';

const useOverflow = () => {
  const [node, setNode] = useState(null);

  const [overflow, setOverflow] = useState({
    x: false,
    y: false,
    any: false,
  });

  const ref = useCallback(el => {
    setNode(el);
  }, []);

  const measure = useCallback(el => {
    if (!el) return;

    const x = el.scrollWidth - el.clientWidth > 1;
    const y = el.scrollHeight - el.clientHeight > 1;

    setOverflow(prev => {
      if (prev.x === x && prev.y === y && prev.any === (x || y)) {
        return prev;
      }

      return { x, y, any: x || y };
    });
  }, []);

  useLayoutEffect(() => {
    if (!node) return;

    measure(node);

    const ro = new ResizeObserver(() => measure(node));
    ro.observe(node);

    const mo = new MutationObserver(() => measure(node));
    mo.observe(node, { childList: true, subtree: true, characterData: true });

    return () => {
      ro.disconnect();
      mo.disconnect();
    };
  }, [node, measure]);

  return { ref, overflow, remeasure: () => node && measure(node) };
};

export default useOverflow;



// WEBPACK FOOTER //
// ./src/hooks/useIsOverflow.js